export default "__VITE_ASSET__w0Z9LLpZ__"